export const LANDING_PAGE_AI_PROMPT_BOX_ID = 'l-ai-chat-prompt-box';
export const AI_LP_HERO_PROMPT_BOX_ID = 'ai-lp-hero-prompt-box';
